<script>
  import { SkeletonText } from "carbon-components-svelte";

  //// data

  import { formatTimeDelta } from "lib/util/formatfunctions.js";

  export let heading = "";
  export let loading = false;

  export let data01 = [{ name: "App01", value: 5 }];
  export let data02 = [{ name: "App01", value: 15 }];

  //// settings

  export let selectedData = 1;

  export let selection01 = "Selection01";
  export let selection02 = "Selection02";

  export let isTime = [false, false];

  function switchData(number) {
    selectedData = number;
  }
</script>

<div class="tile_wrapper">
  <div class="tile_heading">
    <div class="bold">Top {heading}</div>
    <div class="tile_selections">
      <div
        on:click={() => switchData(1)}
        on:keypress={() => switchData(1)}
        class="tile_selection"
        class:active={selectedData === 1}
      >
        {selection01}
      </div>
      <div
        on:click={() => switchData(2)}
        on:keypress={() => switchData(2)}
        class="tile_selection"
        class:active={selectedData === 2}
      >
        {selection02}
      </div>
    </div>
  </div>
  <div class="tile_values">
    {#if loading === true}
      {#each Array(5) as _}
        <div class="tile_value">
          <SkeletonText />
        </div>
      {/each}
    {:else}
      {#if selectedData === 1}
        {#each data01 as entry}
          <div class="tile_value">
            <div class="text">{entry.name}</div>
            <div class="value bold">
              {isTime[0] ? formatTimeDelta(entry.value) : entry.value}
            </div>
          </div>
        {/each}
      {/if}
      {#if selectedData === 2}
        {#each data02 as entry}
          <div class="tile_value">
            <div class="text">{entry.name}</div>
            <div class="value bold">
              {isTime[1] ? formatTimeDelta(entry.value) : entry.value}
            </div>
          </div>
        {/each}
      {/if}
    {/if}
  </div>
</div>

<style>
  .tile_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: white;
    padding: 1rem;
    border-radius: 0.5rem;
  }

  .tile_heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tile_selections {
    display: flex;
    gap: 0.5rem;
  }

  .tile_selection {
    cursor: pointer;
    font-size: 0.8rem;
  }

  .tile_selection:hover {
    text-decoration: underline;
    color: #ff5f1f;
  }

  .active {
    text-decoration: underline;
    color: #ff5f1f;
  }

  .tile_values {
    display: flex;
    flex-direction: column;
    padding-top: 1rem;
    border-top: 1px solid #d9d9d9;
    justify-content: space-between;
    flex-grow: 1;
  }

  .tile_value {
    display: flex;
    justify-content: space-between;
  }

  .text {
    max-width: 20ch;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;
    align-items: flex-end;
  }
</style>
